<div class="container-fluid glb-popup order-list">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (isSearching) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <mat-tab-group class="tabs-group edit-order-grp">
      <mat-tab label="Owner Lead Profile">
        <div [formGroup]="form1" class="forms w-100 d-block">
          <div class="row m-0">

            <div class="col-lg-12">
              @if (formAlert) {
                <div class="w-100 mb-3">
                  <div class="w-100"
                    style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                    <p><b>{{formAlert}}</b></p>
                  </div>
                </div>
              }
            </div>

            <div pTooltip="Name of the order product, its display to customer/guest invoice"  class="col-lg-12">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="name" id="name" type="text" pInputText>
                <label for="name">Name</label>
                @for (validation of validationMessages.name; track validation) {
                  <span>
                    @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Its detail description of the product. not going to show to guest invoice. its used for KBM team" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="description" id="description" [rows]="1" pInputTextarea></textarea>
                <label for="description">Description</label>
                @for (validation of validationMessages.description; track validation) {
                  <span>
                    @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="To store addition details of order prduct. this notes not going to show to customer or owner. its only visible with KBM team" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <textarea formControlName="privateNotes" id="privateNotes" [rows]="1" pInputTextarea></textarea>
                <label for="privateNotes">Private Notes</label>
                @for (validation of validationMessages.privateNotes; track validation) {
                  <span>
                    @if (form1.get('privateNotes').hasError(validation.type) && (form1.get('privateNotes').dirty || form1.get('privateNotes').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy usage with order product 'Ins - Damage $5000', not required to setup new order product tax work-flow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="wholesalePrice" id="wholesalePrice" type="number" pInputText>
                <label for="wholesalePrice">Wholesale Price</label>
                @for (validation of validationMessages.wholesalePrice; track validation) {
                  <span>
                    @if (form1.get('wholesalePrice').hasError(validation.type) && (form1.get('wholesalePrice').dirty || form1.get('wholesalePrice').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Price of the order product without tax. all taxes are applied on this price. when product is sale in reservation." class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="listPrice" id="listPrice" type="number" pInputText>
                <label for="listPrice">List Price</label>
                @for (validation of validationMessages.listPrice; track validation) {
                  <span>
                    @if (form1.get('listPrice').hasError(validation.type) && (form1.get('listPrice').dirty || form1.get('listPrice').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy column, not in use, not required to setup new order product tax work-flow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="listPriceAdjustmentPercent" id="listPriceAdjustmentPercent" type="number" pInputText>
                <label for="listPriceAdjustmentPercent">List Price Adjustment Percent</label>
                @for (validation of validationMessages.listPriceAdjustmentPercent; track validation) {
                  <span>
                    @if (form1.get('listPriceAdjustmentPercent').hasError(validation.type) && (form1.get('listPriceAdjustmentPercent').dirty || form1.get('listPriceAdjustmentPercent').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <!-- Date: 2026-04-09 Author: Alkesh PCT addToRate config — shown only when listPriceAdjustmentPercent is configured -->
            @if (form1.get('listPriceAdjustmentPercent')?.value) {
              <div pTooltip="Select the base amount the PCT percentage is applied against to calculate the fee" class="col-lg-12 mb-3">
                <span class="p-float-label w-100">
                  <p-dropdown class="w-100" [options]="valuePCTAppliedToOptions" formControlName="valuePCTAppliedTo"
                    optionLabel="name" optionValue="value" inputId="valuePCTAppliedTo">
                  </p-dropdown>
                  <label for="valuePCTAppliedTo">PCT Applied To</label>
                </span>
              </div>
              <div pTooltip="When enabled, PCT fee amount is included in the per-night LOS rate calculation for YieldMax sync" class="col-lg-12 mb-3">
                <h6 for="isAddPCTIntoLOS">Include PCT in LOS Rate</h6>
                <div class="flex align-items-center">
                  <p-checkbox [formControl]="form1.controls['isAddPCTIntoLOS']" inputId="isAddPCTIntoLOS" [binary]="true"></p-checkbox>
                  <span class="test-nm">Include PCT in LOS Rate?</span>
                </div>
              </div>
            }

            <div pTooltip="Legacy column, not in use, not required to setup new order product tax work-flow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="listPriceAdjustmentAmount" id="listPriceAdjustmentAmount" type="number" pInputText>
                <label for="listPriceAdjustmentAmount">list Price Adjustment Amount</label>
                @for (validation of validationMessages.listPriceAdjustmentAmount; track validation) {
                  <span>
                    @if (form1.get('listPriceAdjustmentAmount').hasError(validation.type) && (form1.get('listPriceAdjustmentAmount').dirty || form1.get('listPriceAdjustmentAmount').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy column, not in use and not required to setup new order product tax work-flow" class="col-lg-12 mb-3">
              <h6 for="cashPaymentAdjustmentTarget">Cash Payment Adjustment Target</h6>
              <div class="flex align-items-center">
                <p-checkbox [formControl]="form1.controls['cashPaymentAdjustmentTarget']" inputId="cashPaymentAdjustmentTarget" [binary]="true"></p-checkbox>
                <span class="test-nm">Cash Payment Adjustment Target?</span>
              </div>
              @for (validation of validationMessages.cashPaymentAdjustmentTarget; track validation) {
                <span>
                  @if (form1.get('cashPaymentAdjustmentTarget').hasError(validation.type) && (form1.get('cashPaymentAdjustmentTarget').dirty || form1.get('cashPaymentAdjustmentTarget').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </div>

            <div pTooltip="This flag is used with legacy implementation of order product to add sales tax for shortTermRental when product is sale with reservation" class="col-lg-12 mb-3">
              <h6 for="salesTaxable">Sales Taxable</h6>
              <div class="flex align-items-center">
                <p-checkbox [formControl]="form1.controls['salesTaxable']" inputId="salesTaxable" [binary]="true"></p-checkbox>
                <span class="test-nm">Sales Taxable?</span>
              </div>
              @for (validation of validationMessages.salesTaxable; track validation) {
                <span>
                  @if (form1.get('salesTaxable').hasError(validation.type) && (form1.get('salesTaxable').dirty || form1.get('salesTaxable').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </div>

            <div pTooltip="This flag is used with legacy implementation of order product to add room tax for shortTermRental when product is sale with reservation" class="col-lg-12 mb-3">
              <h6 for="roomTaxable">Room Taxable</h6>
              <div class="flex align-items-center">
                <p-checkbox [formControl]="form1.controls['roomTaxable']" inputId="roomTaxable" [binary]="true"></p-checkbox>
                <span class="test-nm">Room Taxable?</span>
              </div>
              @for (validation of validationMessages.roomTaxable; track validation) {
                <span>
                  @if (form1.get('roomTaxable').hasError(validation.type) && (form1.get('roomTaxable').dirty || form1.get('roomTaxable').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </div>

            <div pTooltip="Legacy column, not in use, not required to setup new order product tax work-flow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="value" id="value" type="text" pInputText>
                <label for="value">Value</label>
                @for (validation of validationMessages.value; track validation) {
                  <span>
                    @if (form1.get('value').hasError(validation.type) && (form1.get('value').dirty || form1.get('value').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy column, not in use, not required to setup new order product tax work-flow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="type" id="type" type="text" pInputText>
                <label for="type">Type</label>
                @for (validation of validationMessages.type; track validation) {
                  <span>
                    @if (form1.get('type').hasError(validation.type) && (form1.get('type').dirty || form1.get('type').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy usage with order product 'Option: Couchbed linens requested', 'Option: Couchbed linens declined' & 'Roll Away Bed'" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="productCode" id="productCode" type="text" pInputText>
                <label for="productCode">Product Code</label>
                @for (validation of validationMessages.productCode; track validation) {
                  <span>
                    @if (form1.get('productCode').hasError(validation.type) && (form1.get('productCode').dirty || form1.get('productCode').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div pTooltip="Legacy usage with order product BEDROOM1:KING BEDROOM1:TWINS & ROLLAWAY_BED, " class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <input formControlName="productGroup" id="productGroup" type="number" pInputText>
                <label for="productGroup">Product Group</label>
                @for (validation of validationMessages.productGroup; track validation) {
                  <span>
                    @if (form1.get('productGroup').hasError(validation.type) && (form1.get('productGroup').dirty || form1.get('productGroup').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

			<div pTooltip="Its added the quantity in guest invoice for booking
			Ex. 
			Per reservation: add qty 1
			Per Night: add qty as a number of booking night" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown class="w-100" [options]="feeFrequencies" formControlName="feeFrequency" optionLabel="name"
                optionValue="value" placeholder="Fee Frequency"></p-dropdown>
                <label for="feeFrequency">Fee Frequency</label>
                @for (validation of validationMessages.feeFrequency; track validation) {
                  <span>
                    @if (form1.get('feeFrequency').hasError(validation.type) && (form1.get('feeFrequency').dirty || form1.get('feeFrequency').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

			<div pTooltip="Select 'Mandatory', if its required while booking
			Select 'Optional', if its not required while booking
			Selection is required for new order product workflow" class="col-lg-12">
              <span class="p-float-label w-100 mb-3">
                <p-dropdown class="w-100" [options]="feeTypes" formControlName="feeType" optionLabel="name"
                optionValue="value" placeholder="Fee Type"></p-dropdown>
                <label for="feeType">Fee Type</label>
                @for (validation of validationMessages.feeType; track validation) {
                  <span>
                    @if (form1.get('feeType').hasError(validation.type) && (form1.get('feeType').dirty || form1.get('feeType').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>


            <!-- <div class="col-lg-6 mb-3">
            <h6 for="applyToAllUnit">Apply To All Unit</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['applyToAllUnit']" inputId="applyToAllUnit" [binary]="true"></p-checkbox>
              <span class="test-nm">Apply To All Unit?</span>
            </div>
            <span *ngFor="let validation of validationMessages.applyToAllUnit">
              <small class="p-invalid"
                *ngIf="form1.get('applyToAllUnit').hasError(validation.type) && (form1.get('applyToAllUnit').dirty || form1.get('applyToAllUnit').touched)">{{validation.message}}
              </small>
            </span>
          </div> -->

			<div pTooltip="If this flag enable, then it required to add price for each unit 
			else its not available for unit 
			
			Ex: Housekeeping is Unique per unit and it Mandatory for reservation, and if we have not configured housekeeping price for unit. then its not applied while guest doing booking for unit" class="col-lg-6 mb-3">
            <h6 for="feeUniquePerUnit">Fee Unique Per Unit</h6>
            <div class="flex align-items-center">
              <p-checkbox [formControl]="form1.controls['feeUniquePerUnit']" inputId="feeUniquePerUnit" [binary]="true"></p-checkbox>
              <span class="test-nm">Fee Unique Per Unit?</span>
            </div>
            @for (validation of validationMessages.feeUniquePerUnit; track validation) {
              <span>
                @if (form1.get('feeUniquePerUnit').hasError(validation.type) && (form1.get('feeUniquePerUnit').dirty || form1.get('feeUniquePerUnit').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>



          <!-- <div class="col-lg-6 mb-3">
          <h6 for="active">Active</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['active']" inputId="active" [binary]="true"></p-checkbox>
            <span class="test-nm">Active?</span>
          </div>
          <span *ngFor="let validation of validationMessages.active">
            <small class="p-invalid"
              *ngIf="form1.get('active').hasError(validation.type) && (form1.get('active').dirty || form1.get('active').touched)">{{validation.message}}
            </small>
          </span>
        </div> -->

        <div pTooltip="Amount of this order product added into nighlty rate while reservation is created." class="col-lg-6 mb-3">
          <h6 for="addToRate">Add To Rate</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['addToRate']" inputId="addToRate" [binary]="true"></p-checkbox>
            <span class="test-nm">Add To Rate?</span>
          </div>
          @for (validation of validationMessages.addToRate; track validation) {
            <span>
              @if (form1.get('addToRate').hasError(validation.type) && (form1.get('addToRate').dirty || form1.get('addToRate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div pTooltip="Its used when order product available based on reservation rules: Ex. free rental cars available only if reservation at least for 6 nights" class="col-lg-6 mb-3">
          <h6 for="useBookingRule">Use Booking Rule</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['useBookingRule']" inputId="useBookingRule" [binary]="true"></p-checkbox>
            <span class="test-nm">Use Booking Rule?</span>
          </div>
          @for (validation of validationMessages.useBookingRule; track validation) {
            <span>
              @if (form1.get('useBookingRule').hasError(validation.type) && (form1.get('useBookingRule').dirty || form1.get('useBookingRule').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
        <div pTooltip="This flag is required to set if this product is part of guest invoice else this product only available with ledger" class="col-lg-6 mb-3">
          <h6 for="showToCustomer">Show To Customer as a free</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['showToCustomer']" inputId="showToCustomer" [binary]="true"></p-checkbox>
            <span class="test-nm">Show To Customer as a free?</span>
          </div>
          @for (validation of validationMessages.showToCustomer; track validation) {
            <span>
              @if (form1.get('showToCustomer').hasError(validation.type) && (form1.get('showToCustomer').dirty || form1.get('showToCustomer').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div pTooltip="Order product only available if reservation is created for at least for this number of night. this rule only applied when 'Use Booking Rule' flag is set" class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="applyStaysOfNtsList" formControlName="applyStaysOfAtLeastNts" optionLabel="name"
            optionValue="value" placeholder="Apply Stays Of At Least Nts"></p-dropdown>
            <label for="applyStaysOfAtLeastNts">Apply Stays Of At Least Nts</label>
            @for (validation of validationMessages.applyStaysOfAtLeastNts; track validation) {
              <span>
                @if (form1.get('applyStaysOfAtLeastNts').hasError(validation.type) && (form1.get('applyStaysOfAtLeastNts').dirty || form1.get('applyStaysOfAtLeastNts').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div pTooltip="Order product only available if reservation is created for less than of this number of night. this rule only applied when 'Use Booking Rule' flag is set" class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="applyStaysOfNtsList" formControlName="applyStaysOfLessThanNts" optionLabel="name"
            optionValue="value" placeholder="Apply Stays Of Less Than Nts"></p-dropdown>
            <label for="applyStaysOfLessThanNts">Apply Stays Of Less Than Nts</label>
            @for (validation of validationMessages.applyStaysOfLessThanNts; track validation) {
              <span>
                @if (form1.get('applyStaysOfLessThanNts').hasError(validation.type) && (form1.get('applyStaysOfLessThanNts').dirty || form1.get('applyStaysOfLessThanNts').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="filters" (onChange)="selectedFilters($event)" [(ngModel)]="selectedFilter" optionLabel="name"
            optionValue="value" placeholder=""></p-dropdown>
            <label for="selectedFilter">Select Filter</label>
          </span>
        </div>
        @if (isDataLoaded) {
          <p-pickList #pickList [source]="sourceProperties" [target]="targetProperties" sourceHeader="Available ({{sourceProperties.length}})" targetHeader="Selected ({{targetProperties.length}})"
            [dragdrop]="true" [responsive]="true" [sourceStyle]="{ height: '30rem' }" [targetStyle]="{ height: '30rem' }"
            filterBy="{{selectedFilter}}" sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name"
            breakpoint="1400px" (onMoveAllToSource)="moveAllToSource($event)" (onMoveAllToTarget)="moveAllToTarget($event)" (onMoveToTarget)="moveToTarget($event)" (onMoveToSource)="moveToSource($event)">
            <ng-template let-property pTemplate="item">
              <div class="flex flex-wrap p-2 align-items-center gap-3">
                <div class="flex-1 flex flex-column gap-2">
                  <span class="font-bold">
                    {{ property?.propertyCode }} ({{property?.bedroomNum}} {{property?.adrCity}} {{property?.adrState}} {{property?.adrCounty}})
                  </span>
                  <!-- <div class="flex align-products-center gap-2">
                  <span>
                    {{ property?.adrCity }}
                  </span>
                </div> -->
              </div>
              <!-- <span class="font-bold text-900">
              {{ '$' + product.price }}
            </span> -->
          </div>
        </ng-template>
      </p-pickList>
    }

    @for (targetPropertiesd of [targetProperties]; track targetPropertiesd) {
      <app-order-products-short-term-rental-join-list [orderProductId]="orderProductId" [showFilter]="true" [showPagination]="true" [targetPropertyLength]="targetPropertyLength" (reloadProperties)="reloadProperties($event)"></app-order-products-short-term-rental-join-list>
    }
    <hr>
      <app-order-product-tax-join-list [orderProductId]="orderProductId" [showFilter]="true" [showPagination]="true"></app-order-product-tax-join-list>



    </div>
  </div>
</mat-tab>
<mat-tab label="History">
  @if (orderProductId) {
    <app-audit-list
    [auditUrl]="'order-products/' + orderProductId + '/audit'"></app-audit-list>
  }
</mat-tab>
</mat-tab-group>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          <!-- <button pButton *ngIf="orderProductId" class="btn-delete p-button-outlined p-button-danger"
        (click)="onFormDelete()">Delete Order Product</button> -->
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
        @if (!orderProductId) {
          <button pButton class="btn-addt p-button" (click)="formAdd()">Add Order Product</button>
        }

        @if (orderProductId) {
          <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Order Product</button>
        }
      </div>
    </div>
  </div>
</div>
</div>